import React from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import '../css/WhatsAppFloatingButton.css'
const WhatsAppFloatingButton = () => {
  const phoneNumber = "9494981234"; // Replace with your actual WhatsApp number
  const message = "Hello! I need some assistance."; // Default message
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div className="whatsapp-container">
      <Link to={whatsappLink} target="_blank" rel="noopener noreferrer" className="whatsapp-button">
        <FaWhatsapp size={40} />
      </Link>
    </div>
  );
};

export default WhatsAppFloatingButton;
